import moment from 'moment-timezone'

String.prototype.removeLeadingZero = function() {
  return this.replace(/^0+/, '')
}

Date.prototype.toJSON = function() { 
  return moment(this).tz('Asia/Bangkok').format(); 
}